import { render, staticRenderFns } from "./SliderSwipe.vue?vue&type=template&id=57de3ac0&scoped=true&"
import script from "./SliderSwipe.vue?vue&type=script&lang=js&"
export * from "./SliderSwipe.vue?vue&type=script&lang=js&"
import style0 from "./SliderSwipe.vue?vue&type=style&index=0&id=57de3ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de3ac0",
  null
  
)

/* custom blocks */
import block0 from "./SliderSwipe.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports